import React, { useEffect, useState } from "react";
import "../../main.css";
import { call } from "modules/customer_chats/api_layer/api";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import { createSortHandler } from "modules/utilities/utility";

function IvrTable({ callData }) {
  const [ivrTable, setIvrTable] = useState(callData);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    setIvrTable(callData);
  }, [callData]);


  const handleSortUpdatedDate = () => 
    createSortHandler(
      "updatedAt",
      count,
      setCount,
      setIvrTable,
      setOpa,
      callData || []
    );

  return (
    <div className="border border-rounded scrollable-table">
      <table className="table table-responsive table-striped table-bordered rounded table-hover">
        <thead
          style={{ background:"rgb(249,250,253)" }}
          className="rounded-top text-black"
        >
          <tr className="d-flex">
            <th
              // style={{ minWidth: "14rem" }}
              className="flex-1 align-top text-center"
            >
              Name
            </th>
            <th
              className="flex-1 align-top text-center "
            >
              Email
            </th>
            <th
              style={{ position: "sticky", top: 0 }}
              className="flex-1 d-flex align-top text-center align-items-center justify-content-center mt-n2 cursor-pointer"
              onClick={handleSortUpdatedDate}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                Ivr Call
              </span>
              <span
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <span
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </span>
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "dsc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </span>
            </th>

            <th
              className="flex-1 align-top text-center"
            >
              Type
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(ivrTable) &&
            ivrTable?.map((item, index) => (
              <tr key={index} className="d-flex">
                <td className="flex-1 text-black text-center">{item.user.first_name}22</td>
                <td className="flex-1 text-black text-center">{item.user.email}22</td>
                <td className="flex-1 text-black text-center">{item.event_meta.StartTime}22</td>
                <td className="flex-1 text-black text-center">
                  {item.status === "open" ? "Talk to hair coach" : "Call Done"}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default IvrTable;
